import { render } from "./ItemInfoForm.vue?vue&type=template&id=2a1cf52e"
import script from "./ItemInfoForm.vue?vue&type=script&lang=js"
export * from "./ItemInfoForm.vue?vue&type=script&lang=js"

import "./ItemInfoForm.vue?vue&type=style&index=0&id=2a1cf52e&lang=css"
script.render = render

export default script